import { Component, OnInit} from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { ModuleService } from '../../Services/modules.service';
import { saveAs } from 'file-saver';
import { MemberService } from '../../Services/member.service';
import { Response } from '@angular/http';
import { ModuleResolutionHostAdapter } from '@angular/compiler-cli';
import { Subscription } from 'rxjs/Subscription';
import { GeneralSettingsService } from '../../Services/general-settings.service';

@Component({
    selector: 'nav-menu',
    template: require('./navmenu.component.html'),
    styles: [require('./navmenu.component.css')]
})
export class NavMenuComponent implements OnInit  {
    // membersRusUser: any = {};
    enabledModules: any = [];
    memberPayedChecked:string = '';
    memberPayed:boolean = false;

    showHealthInsurance:boolean = false;
    healthInsurancePaperCheck:boolean = false;
    showMemberShipCard:boolean = false;
    private authSubscription: Subscription;

    constructor(private auth: AuthService, private module: ModuleService, private memberService:MemberService, private generalSettingsService: GeneralSettingsService){
    }

    ngOnInit(){
        this.module.getAllModules().subscribe( (x:any)=>{
            this.enabledModules = x;
        });
        
        this.authSubscription = this.auth.observableAuth.subscribe(item => {
            if (item.id){
                this.checkIfMemberPayed(item.id)    
                this.isHealthInsuranceAvailable()
            }
        });
       
    }

    isHealthInsurancePaperVisible(){
        if (this.healthInsurancePaperCheck){
            if (this.checkIfEnabled('healtinsurancePaper') && this.memberPayed){
                this.showHealthInsurance = true;
            }
            else {
                this.showHealthInsurance = false;
            }
        }else{
            this.showHealthInsurance = false;
        }

    }

    private isMemberShipCardVisible(){
        if (this.checkIfEnabled('memberShipCard') && this.memberPayed){
            this.showMemberShipCard = true;
        }
        else {
            this.showMemberShipCard = false;
        }
    }

    checkIfEnabled(s: string){
        for (var i = 0; i < this.enabledModules.length; i++){
            if (this.enabledModules[i].moduleName == s) {
                return this.enabledModules[i].enabled
            }
        }
        return false;
    }

    isEmptyObject(obj: any) {
        var name;
        for (name in obj) {
            if (obj.hasOwnProperty(name)) {
                return false;
            }
        }
        return true;
    }

    private downloadMemberCard(id: number){
        this.memberService.downloadMembercard(id).subscribe((res: Response) => {
          if (res.headers) {
            if (res.headers) {
              var header = "";
              header = res.headers.get('content-disposition') || "";
              var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
              var endIndex = header.indexOf(";", startIndex);
              var filename = header.substring(startIndex, endIndex);
              saveAs(res.blob(), filename);
            }
          }
        });
    }

    private isHealthInsuranceAvailable(){
        this.generalSettingsService.getHealthInsurancePaperCheck().subscribe( (res:any)=>{
            if (res.status == 200){
                this.healthInsurancePaperCheck = JSON.parse(res.value.healthInsurancePapersAvailable.toLowerCase()); ;
                this.isHealthInsurancePaperVisible();
            }
            // console.log("this.healthInsurancePaperCheck:", this.healthInsurancePaperCheck);

        })
    }

    private checkIfMemberPayed(id:number){
        this.memberService.hasMemberPayed(id).subscribe( (res:any)=>{
            if (res.status == 200){
                this.memberPayed = res.value
            }else{
                this.memberPayed = false;
            }
            this.isHealthInsurancePaperVisible()
            this.isMemberShipCardVisible()
        } )
    }

    private downloadMemberHealthInsurancePaper(id: number){
        this.memberService.downloadHealthInsurancePaper(id).subscribe((res: Response) => {
            if (res.headers) {
              if (res.headers) {
                var header = "";
                header = res.headers.get('content-disposition') || "";
                var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
                var endIndex = header.indexOf(";", startIndex);
                var filename = header.substring(startIndex, endIndex);
                saveAs(res.blob(), filename);
              }
            }
          });
    }
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/navmenu/navmenu.component.ts